// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ja-6";
export var emphasizeQuantity = "_ja-3";
export var flatBottomCorners = "_ja-5";
export var productImage = "_ja-0";
export var quantityContainer = "_ja-2";
export var tooltip = "_ja-1";
export var wrapAndEllipsesOverflow = "_ja-4";